module.exports = __webpack_public_path__ + "img/kim-neutral.8900d8b5.svg";